import React from 'react'
import './hero.scss'
const Hero = ({img, secimg}) => {
  return (
    <div className='hero'>
      <picture>
        <source srcSet={secimg} media="(max-width: 768px)" />
        <img src={img} alt="hero"/>
      </picture>
    </div>
  )
}

export default Hero